import { render, staticRenderFns } from "./DeleteNode.vue?vue&type=template&id=c2684008&scoped=true"
import script from "./DeleteNode.vue?vue&type=script&lang=js"
export * from "./DeleteNode.vue?vue&type=script&lang=js"
import style0 from "./DeleteNode.vue?vue&type=style&index=0&id=c2684008&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2684008",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\G\\YT\\mes-project-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c2684008')) {
      api.createRecord('c2684008', component.options)
    } else {
      api.reload('c2684008', component.options)
    }
    module.hot.accept("./DeleteNode.vue?vue&type=template&id=c2684008&scoped=true", function () {
      api.rerender('c2684008', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/SimpleFlow/src/components/DeleteNode.vue"
export default component.exports